function createTheme(theme) {
  return theme;
}

export { createTheme };
//# sourceMappingURL=create-theme.mjs.map
